export default __webpack_public_path__ + "static/media/scene_02.0e3dfda9.mp3";